// import Vue from 'vue'
import { Model } from '@vuex-orm/core'

// import Composition from './composition.model'

export default class Product extends Model {
  static entity = 'products'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      basePrice: this.number(0),
      baseCountItems: this.number(0),
      compositions: this.attr([]), // this.belongsTo(Composition, 'product_id'),
      aditions: this.attr([]),
    }
  }
}
